'use client';

import { experimental_extendTheme as extendTheme } from '@mui/material/styles';

import ColorSchemes from './color-schemes';
import { customShadow } from './custom-shadow';
import { typography } from './typography';
import * as components from './variants';

export const theme = extendTheme({
  cssVarPrefix: 'epos',
  colorSchemes: ColorSchemes,
  components,
  typography,
  customShadow,
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1440
    }
  }
});
